<spinner-overlay></spinner-overlay>
<div class="flex items-center justify-center min-h-screen bg-gradient">
  <div class="bg-white rounded-lg p-8 w-full max-w-md" style="box-shadow: 0 25px 50px 0 rgba(0, 0, 0, 0.25);">
    <div class="flex justify-center mb-6">
      <svg width="198" height="155" viewBox="0 0 198 155" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_6001_1850)">
        <path d="M134.176 14.9054C124.457 5.18609 111.721 0.334229 99 0.334229C86.2794 0.334229 73.5277 5.18609 63.8084 14.9054C44.3699 34.3439 44.3699 65.8499 63.8084 85.2729C73.5277 94.9922 86.2638 99.8441 99 99.8441C111.736 99.8441 124.472 94.9922 134.192 85.2729C153.63 65.8344 153.63 34.3284 134.192 14.9054H134.176ZM66.5609 17.6579C75.2227 8.99605 86.7459 4.22194 99 4.22194C111.254 4.22194 122.777 8.99605 131.439 17.6579C135.544 21.7633 138.701 26.4596 140.925 31.4826L117.163 55.2443C114.053 53.2226 110.01 53.2226 106.9 55.2443L93.8682 42.2127C94.8634 40.7042 95.3922 38.9314 95.3922 37.0809C95.3922 34.5616 94.4125 32.1979 92.6397 30.4251C90.8669 28.6523 88.5031 27.6726 85.9839 27.6726C83.4647 27.6726 81.1009 28.6523 79.3281 30.4251C76.1247 33.6286 75.7204 38.5738 78.0996 42.2127L55.5509 64.7614C50.1859 48.7596 53.8559 30.3785 66.5609 17.6734V17.6579ZM108.113 59.2097C110.259 57.0637 113.773 57.0482 115.919 59.2097C118.065 61.3557 118.065 64.8702 115.919 67.0163C113.773 69.1623 110.259 69.1623 108.113 67.0163C105.967 64.8702 105.967 61.3557 108.113 59.2097ZM82.0651 33.1621C83.107 32.1202 84.491 31.5448 85.9684 31.5448C87.4457 31.5448 88.8297 32.1202 89.8716 33.1621C90.9135 34.204 91.4889 35.588 91.4889 37.0653C91.4889 38.5427 90.9135 39.9267 89.8716 40.9686C87.7878 43.0524 84.1489 43.0524 82.0651 40.9686C79.9191 38.8226 79.9191 35.3081 82.0651 33.1621ZM131.423 82.536C122.762 91.1978 111.238 95.9719 98.9844 95.9719C86.7303 95.9719 75.2072 91.1978 66.5454 82.536C62.4399 78.4306 59.2831 73.7342 57.0593 68.7113L80.821 44.9496C82.3295 45.9449 84.1023 46.4736 85.9528 46.4736C87.8034 46.4736 89.5762 45.9449 91.0846 44.9496L104.116 57.9812C103.121 59.4896 102.592 61.2624 102.592 63.113C102.592 65.6322 103.572 67.9959 105.345 69.7687C107.18 71.6037 109.59 72.5212 112 72.5212C114.411 72.5212 116.821 71.6037 118.656 69.7687C120.429 67.9959 121.409 65.6322 121.409 63.113C121.409 61.2624 120.88 59.4896 119.885 57.9812L142.433 35.4325C147.799 51.4343 144.129 69.8154 131.423 82.5204V82.536Z" fill="url(#paint0_linear_6001_1850)"/>
        <path d="M0.0577393 124.357H3.41672V154.153H0.0577393V124.357Z" fill="url(#paint1_linear_6001_1850)"/>
        <path d="M19.5429 124.357L38.3128 148.228V124.357H41.594V154.153H38.9037L19.6674 129.722V154.153H16.3861V124.357H19.5429Z" fill="url(#paint2_linear_6001_1850)"/>
        <path d="M52.3241 149.814L54.4079 147.341C57.5181 150.156 60.4883 151.556 64.6248 151.556C68.7614 151.556 71.2651 149.425 71.2651 146.486V146.393C71.2651 143.625 69.7722 142.054 63.5207 140.732C56.6628 139.239 53.5215 137.031 53.5215 132.133V132.055C53.5215 127.374 57.6425 123.922 63.3186 123.922C67.6573 123.922 70.7674 125.15 73.7843 127.576L71.8249 130.173C69.0568 127.918 66.2888 126.939 63.2253 126.939C59.3531 126.939 56.8805 129.069 56.8805 131.744V131.822C56.8805 134.636 58.4201 136.207 64.967 137.606C71.6072 139.053 74.6707 141.479 74.6707 146.035V146.128C74.6707 151.229 70.4098 154.557 64.5004 154.557C59.773 154.557 55.9008 152.986 52.3241 149.783V149.814Z" fill="url(#paint3_linear_6001_1850)"/>
        <path d="M86.085 124.357H89.444V154.153H86.085V124.357Z" fill="url(#paint4_linear_6001_1850)"/>
        <path d="M101.107 139.255C101.107 131.091 107.11 123.844 116.051 123.844C121.074 123.844 124.185 125.29 127.155 127.809L124.978 130.36C122.676 128.354 120.126 126.954 115.912 126.954C109.318 126.954 104.591 132.537 104.591 139.177V139.255C104.591 146.362 109.147 151.633 116.378 151.633C119.784 151.633 122.925 150.312 124.978 148.648V141.245H115.912V138.229H128.212V150.109C125.444 152.582 121.277 154.666 116.254 154.666C106.892 154.666 101.107 147.854 101.107 139.348V139.255Z" fill="url(#paint5_linear_6001_1850)"/>
        <path d="M140.062 124.357H143.421V137.591H160.62V124.357H163.979V154.153H160.62V140.748H143.421V154.153H140.062V124.357Z" fill="url(#paint6_linear_6001_1850)"/>
        <path d="M184.537 127.467H174.538V124.357H197.942V127.467H187.943V154.153H184.537V127.467Z" fill="url(#paint7_linear_6001_1850)"/>
        </g>
        <defs>
        <linearGradient id="paint0_linear_6001_1850" x1="49.2295" y1="0.334229" x2="168.57" y2="60.7012" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6D28D9"/>
        <stop offset="1" stop-color="#14B8A6"/>
        </linearGradient>
        <linearGradient id="paint1_linear_6001_1850" x1="0.0577393" y1="123.844" x2="25.8757" y2="207.665" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6D28D9"/>
        <stop offset="1" stop-color="#14B8A6"/>
        </linearGradient>
        <linearGradient id="paint2_linear_6001_1850" x1="0.0577393" y1="123.844" x2="25.8757" y2="207.665" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6D28D9"/>
        <stop offset="1" stop-color="#14B8A6"/>
        </linearGradient>
        <linearGradient id="paint3_linear_6001_1850" x1="0.0577393" y1="123.844" x2="25.8757" y2="207.665" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6D28D9"/>
        <stop offset="1" stop-color="#14B8A6"/>
        </linearGradient>
        <linearGradient id="paint4_linear_6001_1850" x1="0.0577393" y1="123.844" x2="25.8757" y2="207.665" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6D28D9"/>
        <stop offset="1" stop-color="#14B8A6"/>
        </linearGradient>
        <linearGradient id="paint5_linear_6001_1850" x1="0.0577393" y1="123.844" x2="25.8757" y2="207.665" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6D28D9"/>
        <stop offset="1" stop-color="#14B8A6"/>
        </linearGradient>
        <linearGradient id="paint6_linear_6001_1850" x1="0.0577393" y1="123.844" x2="25.8757" y2="207.665" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6D28D9"/>
        <stop offset="1" stop-color="#14B8A6"/>
        </linearGradient>
        <linearGradient id="paint7_linear_6001_1850" x1="0.0577393" y1="123.844" x2="25.8757" y2="207.665" gradientUnits="userSpaceOnUse">
        <stop stop-color="#6D28D9"/>
        <stop offset="1" stop-color="#14B8A6"/>
        </linearGradient>
        <clipPath id="clip0_6001_1850">
        <rect width="197.884" height="154.332" fill="white" transform="translate(0.0577393 0.334229)"/>
        </clipPath>
        </defs>
        </svg>
    </div>
    <h2 class="text-center text-lg font-normal text-black my-[30px]">Sign in to your account</h2>

    <!-- SSO login options - Don't include B2C in the dynamic buttons since we'll show the form instead -->
    <div class="flex items-center justify-items-center w-full">
      <div class="w-full flex flex-col space-y-3">
        <!-- Dynamic provider buttons (excluding B2C) -->
        <ng-container *ngFor="let provider of authProviders">
          <!-- Skip B2C as it uses the form login -->
          <div *ngIf="provider.id !== 'azureB2C'"
            class="appearance-none flex items-center justify-between w-full shadow rounded-md py-1 px-3 leading-tight hover:bg-gray-50 text-gray-700 bg-white focus:outline-none border border-gray-300 cursor-pointer"
            style="height: 38px;" (click)="providerLogin(provider)">
            <div class="flex items-center">
              <img *ngIf="provider.logoPath" [src]="provider.logoPath" [alt]="'Login with ' + provider.displayName" style="height: 16.1px; margin-right: 10px;">
              <!-- <span class="font-medium">{{ provider.displayName }}</span> -->
            </div>
            <!-- Right chevron -->
            <svg class="text-gray-400" style="height: 15px;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
            </svg>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- separator - only show if B2C is enabled and there are other providers -->
    <div *ngIf="b2cEnabled" class="flex flex-wrap order-2 mt-[20px] mb-[20px]">
      <div class="flex flex-col items-center justify-items-center w-full">
        <div class="flex flex-row items-center w-full">
          <div class="divider-bg w-full h-px">&nbsp;</div>
          <div
            class="w-full text-gray-900 flex-1 text-center text-base font-normal font-inter whitespace-nowrap px-2.5">or
          </div>
          <div class="divider-bg w-full h-px">&nbsp;</div>
        </div>
      </div>
    </div>

    <!-- Direct login form (Azure B2C) - now with only email field -->
    <div *ngIf="b2cEnabled" class="flex flex-wrap">
      <form [formGroup]="loginForm" (ngSubmit)="login()" class="w-full">
        <!-- <h3 class="text-center text-base font-medium text-gray-700 mb-3">{{ runtimeConfig.auth?.azureB2C?.displayName }}</h3> -->
        <div class="flex flex-wrap space-y-[20px]">
          <!--username/email field-->
          <div class="relative w-full md:w-full">
            <label class="form-label" for="username">
              Email
            </label>
            <input formControlName="username"
              class="form-input"
              type="email" id="username" placeholder="Email" />
            <div *ngIf="username.invalid && (username.dirty || username.touched)" class="mt-1 text-xs text-red-600">
              <span *ngIf="username.errors?.required">Email is required.</span>
              <span *ngIf="username.errors?.email">Please enter a valid email address.</span>
            </div>
          </div>

          <!--Sign In button-->
          <div class="w-full relative">
            <button [disabled]="loginForm.invalid || isWorking"
              class="ids-button-primary mt-2.5"
              type="submit">
              <span>Continue with Email</span>
            </button>
            <div *ngIf="isWorking" class="ids-button-primary-spinner"></div>
          </div>

          <!-- Optional description text -->
          <div class="text-center text-sm text-gray-500 mt-2">
            You'll complete sign-in securely on the next page
          </div>
        </div>
      </form>
    </div>

    <!-- Error message -->
    <div *ngIf="message" class="mt-4 text-center">
      <span class="text-red-600 font-inter text-center"> {{message}} </span>
    </div>
    
    <!-- Debug information section (only shown in debug mode) -->
    <div *ngIf="isDebugMode" class="mt-6 text-xs p-3 bg-gray-100 rounded-md">
      <div class="flex justify-between items-center mb-2">
        <h6 class="font-semibold">Debug Information</h6>
        <span class="text-xs px-2 py-1 bg-blue-100 text-blue-800 rounded">{{ debugInfo.environment }}</span>
      </div>
      <pre class="whitespace-pre-wrap overflow-auto max-h-48">{{ debugInfo | json }}</pre>
    </div>
  </div>
</div>
